<template>
  <v-layout row wrap class="pt-2" data-qa="transactions-layout-p94gy9">
    <Loader v-if="loaderEnabled"/>
    <v-flex class="pb-2" xs12 sm12 md12 lg12 xl12 v-if="showCustomList" data-qa="transactions-flex-8heq3i">
      <v-flex xs12 sm12 md12 lg8 xl8 class="pa-1" data-qa="transactions-flex-zjg4hs">
        <v-chip-group v-model="defaultFilter" :color="primaryColor" mandatory data-qa="transactions-chip-group-nwttzt">
          <v-chip v-if="chip0" outlined class="ma-2" :color="primaryColor"  @click="showCustomFilterList(); resetFormattedDate();" data-qa="transactions-chip-2jr0gk">
            {{ $t("accountTransaction.customFilter") }}
          </v-chip>
          <v-chip
            v-if="chip1"
            outlined
            class="ma-2"
            :color="primaryColor"
            @click="last7DaysTransactions"

           data-qa="transactions-chip-s8fc6">
            {{ $t("accountTransaction.last7Days") }}
          </v-chip>
          <v-chip
            v-if="chip2"
            outlined
            class="ma-2"
            :color="primaryColor"
            @click="last15DaysTransactions"
           data-qa="transactions-chip-a3vv37">
            {{ $t("accountTransaction.last15Days") }}
          </v-chip>
          <v-chip
            v-if="chip3"
            outlined
            class="ma-2"
            :color="primaryColor"
            @click="thisMonthTransactions"
           data-qa="transactions-chip-4w1ozt">
            {{ $t("accountTransaction.thisMonth") }}
          </v-chip>
            <v-chip
              v-if="chip4"
              outlined
              class="ma-2"
              :color="primaryColor"
              @click="lastMonthTransactions"
             data-qa="transactions-chip-ysbfp">
              {{ $t("accountTransaction.lastMonths") }}
            </v-chip>
            <v-chip
              v-if="chip5"
              outlined
              class="ma-2"
              :color="primaryColor"
              @click="last180DaysTransactions"
             data-qa="transactions-chip-oyl4ab">
              {{ $t("accountTransaction.last6Months") }}
            </v-chip>
            <v-chip
              v-if="chip6"
              outlined
              class="ma-2"
              :color="primaryColor"
              @click="last360DaysTransactions()"
             data-qa="transactions-chip-9gb6g">
              {{ $t("accountTransaction.last6Months1year") }}
            </v-chip>
        </v-chip-group>
      </v-flex>

      <v-expand-x-transition data-qa="transactions-expand-x-transition-lovziu">
        <v-flex xs12 sm12 md6 lg6 xl6 data-qa="transactions-flex-b5hdu">
          <v-row no-gutters v-show="expandCustomList" data-qa="transactions-row-i0hwji">
            <v-flex class="pl-4 pr-4 md-4" xs5 sm5 md4 lg4 xl4 data-qa="transactions-flex-1w2iv9">
              <v-menu
                min-width="auto"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
               data-qa="transactions-menu-2st9zv">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedFromDate"
                    :label="$t('accountTransaction.fromDate')"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    data-qa="fromDate"
                    :color="primaryColor"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDate"
                  @input="menu = false"
                  :allowed-dates="allowedDates"
                  :min="minAllowedDate"
                  :max="currentDate"
                  data-qa="fromDate"
                  :color="primaryColor"
                  @change="updateFormattedDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex class="pl-4 pr-2 md-4" xs5 sm5 md4 lg4 xl4 data-qa="transactions-flex-2upysh">
              <v-menu
                min-width="auto"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
               data-qa="transactions-menu-ze3agb">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedToDate"
                    :label="$t('accountTransaction.toDate')"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    data-qa="toDate"
                    :color="primaryColor"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toDate"
                  @input="menu2 = false"
                  :allowed-dates="allowedDates"
                  :min="minAllowedDate"
                  :max="currentDate"
                  data-qa="toDate"
                  :color="primaryColor"
                  @change="updateFormattedDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs1 sm1 md2 lg1 xl1 class="pl-2 pr-4 pt-4 md-4" data-qa="transactions-flex-cmq4sj">
              <v-btn
                fab
                outlined
                small
                :color="primaryColor"
                @click="getCustomTransactionsHandler(fromDate, toDate)"
                data-qa="getCustomTransaction"
              >
                <v-icon dark class="material-symbols-outlined" data-qa="transactions-icon-pkc2e">arrow_right_alt</v-icon>
              </v-btn>
            </v-flex>

            <!-- <v-flex
              xs12
              sm12
              md12
              lg1
              xl1
              class="pl-5 pr-5 pt-4 hidden-md-and-up" data-qa="transactions-flex-vrzklo">
              <v-btn
                block
                :color="primaryColor"
                outlined
                @click="getCustomTransactions(fromDate, toDate)"
                data-qa="getCustomTransaction"
              >{{ $t("accountDetails.lookupTransaction") }}
              </v-btn>
            </v-flex> -->
          </v-row>
        </v-flex>
      </v-expand-x-transition>
    </v-flex>
    <v-flex xs12 sm12 md8 lg6 xl6 class="pa-2 pl-5 text-left" v-if="dateError" data-qa="transactions-flex-ans53">
      <v-alert icon="mdi-alert-circle" class="v-alert--error" data-qa="transactions-alert-epqzlw">
        <font class="body-2">{{ $t("accountTransaction.transactionError") }}</font>
      </v-alert>
    </v-flex>
    <v-flex xs12 sm12 md12 lg12 xl12 class="pa-2 text-left" v-if="showList && config.defaultAccountType != 'TXSV'" data-qa="transactions-flex-p374">
      <v-btn
        class="ml-2 my-1 me-16 py-2 px-4"
        small
        outlined
        :color="primaryColor"
        @click="printCSVContent"
        v-if="items && items.length"
       data-qa="transactions-btn-auxbo9">
        <font class="button text-capitalize"
          >{{ $t("accountTransaction.exportPdf") }}&nbsp;&nbsp;</font
        >
        <v-icon class="material-symbols-outlined" size="18px" data-qa="transactions-icon-ql9qp">download</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12 sm12 md8 lg8 xl6 class="pa-2 ml-3" v-if="showList" data-qa="transactions-flex-jftpqt">
      <!--Show card view for all accounts-->
      <div id="pdfContent" data-qa="transactions-div-lpy9p7">
        <v-card class="text-left" data-qa="transactions-card-dzepr9">
          <div v-for="(item,i) in config.defaultAccountType === 'TXSV' ? helperArr : items" :key="item.transactionSRID" :data-qa="`transactions-div-1j0v8-${i}`">
            <div
              v-if="
                transactionReversalIndicator === true ||
                item.reversalIndicator === false
              "
              :data-qa="`transactions-div-yjlc6r-${i}`">
              <!--All repeated item content-->
              <v-list-item two-line :data-qa="`transactions-list-item-e4g4i-${i}`" @click="toggleExpand(i)">
                <v-list-item-content :data-qa="`transactions-list-item-content-uxyscd-${i}`">
                  <div class="mb-0" :data-qa="`transactions-div-fz5fjn-${i}`">
                    <v-row>
                      <v-col cols="1">
                        <v-icon color="green" v-if="item.creditDebitIndicator === 'CREDIT'"
                          :data-qa="`transactions-icon-ep1mx5-${i}`">mdi-arrow-bottom-right</v-icon>
                        <v-icon color="red" v-else :data-qa="`transactions-icon-pp9z0q-${i}`">mdi-arrow-top-left
                        </v-icon>
                      </v-col>
                      <v-col cols="11" class="pl-1">
                        <font v-if="item.postingType.includes('SW0')" class="subtitle-2 font-weight-normal text-wrap">
                          {{ formatItemDescription(item.description?.substring(0,8)) }}</font>
                        <font v-else class="subtitle-2 font-weight-normal text-wrap">
                          {{ formatItemDescription(item.description) }}</font>
                        <v-list-item-subtitle v-if="!expandTransactionEnabled" class="mb-0" :data-qa="`transactions-list-item-subtitle-yartp-${i}`">{{
                          $formatter.formatDate(item.valueDateTime.substr(0, 10))
                        }}</v-list-item-subtitle>
                      </v-col>
                    </v-row>
                  </div>
                </v-list-item-content>

                <v-list-item-action :data-qa="`transactions-list-item-action-g1u2u9-${i}`">
                  <v-list-item-action-text :data-qa="`transactions-list-item-action-text-d3099-${i}`">
                    <font
                      class="subtitle-1 font-weight-bold"
                      >{{
                        $formatter.currency.format(item.amount.amount, item.amount.currency)
                      }}</font
                    >
                  </v-list-item-action-text>
                  <v-list-item-action-text
                    v-if="
                      item && item.clearedBalance && item.clearedBalance.amount
                    "
                    :data-qa="`transactions-list-item-action-text-1ksxpq-${i}`">
                    <font class="subtitle-2">{{
                      $formatter.currency.format(item.clearedBalance.amount, item.amount.currency)
                    }}</font>
                  </v-list-item-action-text>
                </v-list-item-action>
                <div class="pl-2 mb-4" v-if="expandTransactionEnabled  && addtlTransactionDetails.length > 0">
                  <v-icon class="mb-4" :color="primaryColor">
                    {{ expandedIndex === i ? 'mdi-chevron-up' : 'mdi-chevron-down'}}
                  </v-icon>
                </div>
              </v-list-item>
              <v-expand-transition v-if="expandTransactionEnabled && addtlTransactionDetails.length > 0">
                <div v-if="expandedIndex === i">
                  <v-list-item three-line>
                    <v-list-item-content class="mb-0 ml-8">
                      <v-row>
                        <v-col cols="12">
                          <v-list-item-subtitle
                            v-for="(label, index) in addtlTransactionDetails"
                            :key="index"
                            :class="{ 'mt-1': index !== 0 }"
                          >
                            <font class="body-2 font-weight-bold text-wrap">{{ $t(`accountTransaction.${label}`) }}</font>
                          </v-list-item-subtitle>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action class="pr-4">
                      <v-list-item-action-text
                        v-for="(data, index) in addtlTransactionDetails"
                        :key="index"
                        :class="{ 'mt-1': index !== 0 }"
                      >
                        <span v-if="['bookingDateTime', 'valueDateTime'].includes(data)" class="subtitle-2 pr-4">
                          {{$formatter.formatDateTime(item[data], {outputFormat: `${displayDateFormat} hh:mm:ss A`, local: true})}}
                        </span>
                        <span v-else-if="['amount', 'clearedBalance'].includes(data)" class="subtitle-2 pr-4">
                          {{ $formatter.currency.format(item[data].amount, item[data].currency) }}
                        </span>
                        <span v-else class="subtitle-2 pr-4">{{ item[data] }}</span>
                      </v-list-item-action-text>
                    </v-list-item-action>
                  </v-list-item>
                </div>
              </v-expand-transition>
              <!--End repeated-->
              <v-divider :data-qa="`transactions-divider-xose3s-${i}`"></v-divider>
            </div>
          </div>
        </v-card>
      </div>
      <!--end card view-->
      <v-flex xs12 sm12 md12 lg12 xl12 class="pa-2" v-if="(pagination.page > 1 || (pagination.page === 1 && items && items.length)) && config.defaultAccountType !== 'TXSV'" data-qa="transactions-flex-4qkfop">
         <v-alert v-if="!items.length" icon="mdi-information-outline" class="v-alert--info" data-qa="transactions-alert-b7ens">
          <font class="body-2">
            {{ $t("accountTransaction.noTransactions") }}
          </font>
        </v-alert>
        <v-pagination
          @input="paginationChangeHandler"
          :value="pagination.page"
          :length="pageNumbers"
          :total-visible="6"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          circle
         data-qa="transactions-pagination-cyj3qo"></v-pagination>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 class="pa-2" v-else-if="config.defaultAccountType === 'TXSV'" data-qa="transactions-flex-v5mtfw">
         <v-alert v-if="!items.length" icon="mdi-information-outline" class="v-alert--info" data-qa="transactions-alert-tiq04m">
          <font class="body-2">
            {{ $t("accountTransaction.noTransactionsCashISA") }}
          </font>
        </v-alert>
        <v-pagination
          @input="paginationHandler"
          v-model="curPage"
          :length="noOfPages"
          :total-visible="6"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          circle
         data-qa="transactions-pagination-a6j2td"></v-pagination>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 class="text-left" v-else data-qa="transactions-flex-5mamea">
        <v-alert v-if="!dateError" icon="mdi-information-outline" class="v-alert--info" data-qa="transactions-alert-feza4">
          <font class="body-2">
            {{ config.defaultAccountType === 'TXSV' ? $t("accountTransaction.noTransactionsCashISA")
            : $t("accountTransaction.noTransactions") }}
          </font>
        </v-alert>
      </v-flex>
    </v-flex>
    <v-flex class="pa-2 ml-3 text-left" xs12 sm12 md7 lg7 xl7 v-if="(items && items.length) && !isAccountRestricted" data-qa="transactions-flex-1n024i">
      <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="transactions-alert-sl8la">
        <font class="body-2">
          {{ config.defaultAccountType === 'TXSV' ? $t("accountTransaction.tooltipCashISA")
            : $t("accountTransaction.tooltip") }}
        </font>
      </v-alert>
    </v-flex>
  </v-layout>
</template>
<style lang="scss" scoped>
#pdfContent {
  width: 100%;
  height: auto;
  display: block;
}
</style>
<script>
import commonService from '@/service/commonService.js'
import preload from '@/util/preload'
import html2canvas from 'html2canvas'
import _ from 'lodash'
import Loader from '../../components/common/Loader.vue'
import moment from 'moment'

const { jsPDF } = require('jspdf')

export default {
  name: 'Transactions',
  components: { Loader },
  props: {
    config: Object
  },
  data () {
    return {
      expandCustomList: false,
      isAccountRestricted: false,
      chip0: true,
      chip1: false,
      chip2: false,
      chip3: false,
      chip4: false,
      chip5: true,
      chip6: true,
      items: [],
      itemLinks: {},
      itemGroups: {},
      expandedIndex: null,
      showList: false,
      loaderEnabled: false,
      showCustomFilter: true,
      loading: false,
      enableLinks: false,
      transactionReversalIndicator: this.$appSettings.defaultConfigurations
        .includeReversedTransactionInHistory,
      expandTransactionEnabled: this.$appSettings.defaultConfigurations.enableExpandTransactionDetails,
      addtlTransactionDetails: this.$appSettings.uiFieldsDisplayConfigurations.transactionDetails.inclusionList,
      itemsPerPage: 30,
      offset: 0,
      pageNumbers: 5,
      startDate: '',
      endDate: '',
      pagination: { rowsPerPage: this.itemsPerPage, page: this.pageNumbers },
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      currentDate: moment().format('YYYY-MM-DD'),
      minAllowedDate: moment().subtract(parseInt(this.$appSettings.defaultConfigurations.transactionCustomFilter.minAllowedDays.CASA), 'days').format('YYYY-MM-DD'),
      showCustomList: true,
      defaultFilter: 1,
      dateError: false,
      menu: false,
      menu2: false,
      select: { state: 'Select Date Range', val: 'custom' },
      postingsRestrictions: ['DEBITCREDIT', 'ACCSTOPENQ', 'ACCSTOPENQWITHREF'],
      headers: [
        {
          text: 'Date',
          value: 'valueDateTime',
          sortable: false,
          filterable: false
        },
        {
          text: 'Transaction Id',
          value: 'transactionId',
          sortable: false,
          filterable: false
        },
        {
          text: 'Transaction Description',
          value: 'description',
          sortable: false,
          filterable: false
        },
        {
          text: 'Dr/Cr',
          value: 'creditDebitIndicator',
          sortable: true,
          filterable: true,
          align: 'center'
        },
        {
          text: 'Amount',
          value: 'amount.amount',
          sortable: false,
          filterable: false
        },
        {
          text: 'Balance',
          value: 'clearedBalance.amount',
          sortable: false,
          filterable: false
        }
      ],
      sixMonths: moment().subtract(180, 'days').format('YYYY-MM-DD'),
      twelveMonths: moment().subtract(360, 'days').format('YYYY-MM-DD'),
      last6Offset: 0,
      last12Offset: 0,
      hasMoreIn6: false,
      hasMoreIn12: false,
      curPage: 1,
      helperArr: [],
      noOfPages: 0,
      displayDateFormat: this.$appSettings.defaultConfigurations.dateFormat.uiFormat
    }
  },
  async created () {
    if (this.config.defaultAccountType === 'credit' || this.config.defaultAccountType === 'debit') {
      this.accountId = this.$route.params.cardId
    } else {
      this.accountId = this.$route.params.accountId
    }
    if (this.config.defaultAccountType === 'TXSV') {
      this.chip0 = false
      this.chip1 = false
      this.chip2 = false
      this.chip3 = false
      this.chip4 = false
      this.chip5 = false
      this.chip6 = false
      // TODO this.minAllowedDate = this.getDate(360)
    }
    this.resetFormattedDate()
    const exclusionList = this.$appSettings.uiFieldsDisplayConfigurations
      .tableColumns.transactionsTable.exclusionList
    if (exclusionList && exclusionList.length) {
      this.headers = preload.filterTableColumns(exclusionList, this.headers)
    }
    if (
      this.postingsRestrictions.includes(this.config.postingRestrictionType)
    ) {
      this.isAccountRestricted = true
    } else {
      this.isAccountRestricted = false
      /** TXSV transaction list should be for the entire tax year */
      if (this.config.defaultAccountType === 'TXSV') {
        await this.getCurrentTaxYearTransactions(this.accountId)
      } else {
        await this.last180DaysTransactions()
      }
    }
  },
  methods: {
    /**
     * Start : Cash ISA Transaction Listing logic
     * CASH ISA has to list the entire 360 days transaction list with paginiation and without filters
     * The issue here is that the essence's fetch transaction api returns only data upto 6 months in a single call so 2 api calls has to be made to this endpoint (0-6 months and 6-12 months),
     * and the result set should be paginated - so we are using a UI pagination logic here.
     * cases:
     *  - if the 0-6 months call returns no data then call the 6-12 to see if there is any data and display it
     *  - if the 0-6 returns a full set of data and has more data then call this endpoint until there is no more and only then call the 6-12
     *  - if the amount of data in 0-6 is less than items per page then call the 6-12 fill the rest of it and then display and if nothing then display as such
     */
    async paginationHandler () {
      let startP, endP

      if (this.items.length > 0 && this.curPage === this.noOfPages && this.hasMoreIn6) {
        await this.getAllOf6Trans(this.accountId, this.sixMonths, this.currentDate, this.itemsPerPage, this.last6Offset)
      }

      if (this.items.length > 0 && this.curPage === this.noOfPages && this.hasMoreIn12) {
        await this.getAllOf12Trans(this.accountId, this.twelveMonths, this.sixMonths, this.itemsPerPage, this.last12Offset)
      }

      if (this.items.length > 0) {
        if (this.curPage === 1) {
          startP = 0
          endP = (this.curPage * this.itemsPerPage)
        } else if (this.curPage === this.noOfPages) {
          startP = (this.curPage * this.itemsPerPage) - this.itemsPerPage
        } else {
          startP = startP = (this.curPage * this.itemsPerPage) - this.itemsPerPage
          endP = (this.curPage * this.itemsPerPage)
        }
        this.helperArr = this.items.slice(startP, endP)
      }
    },
    async getCurrentTaxYearTransactions (accountID) {
      await this.getAllOf6Trans(accountID, this.sixMonths, this.currentDate, this.itemsPerPage, 0)
      this.paginationHandler()
      this.showList = true
    },
    async getAllOf6Trans (accountID, startDt, endDt, limit, offset, round = 0) {
      this.hasMoreIn6 = false
      const resp = await commonService.casaTransactions(accountID, startDt, endDt, limit, offset)
      if (resp.items) {
        this.items.push(...resp.items)
        if (resp.links.next && round < 1) {
          await this.getAllOf6Trans(accountID, startDt, endDt, limit, offset + limit, round + 1)
        } else if (resp.links.next && round === 1) {
          this.last6Offset = offset + limit
          this.hasMoreIn6 = true
        } else if (round < 1 || (round === 1 && this.items.length < ((round + 1) * limit))) {
          await this.getAllOf12Trans(accountID, this.twelveMonths, startDt, limit, this.last12Offset, round)
        }
      } else if (round < 1 || (round === 1 && this.items.length < ((round + 1) * limit))) {
        await this.getAllOf12Trans(accountID, this.twelveMonths, startDt, limit, this.last12Offset, round)
      }
    },
    async getAllOf12Trans (accountID, startDt, endDt, limit, offset, round = 0) {
      this.hasMoreIn12 = false
      const resp = await commonService.casaTransactions(accountID, startDt, endDt, limit, offset)
      if (resp.items) {
        this.items.push(...resp.items)
        if (resp.links.next && round < 1) {
          await this.getAllOf12Trans(accountID, startDt, endDt, limit, offset + limit, round + 1)
        } else if (resp.links.next && round === 1) {
          this.last12Offset = offset + limit
          this.hasMoreIn12 = true
        }
      }
    },
    /** End : Cash ISA Transaction Listing logic */
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    async getTransactions (accountNumber, startDate, endDate, limit, offset) {
      if (
        this.postingsRestrictions.includes(this.config.postingRestrictionType)
      ) {
        this.isAccountRestricted = true
      } else {
        this.isAccountRestricted = false
        let response = {}
        if (this.config.defaultAccountType === 'credit') {
          response = await commonService.getCreditCardTransactions(
            accountNumber,
            startDate,
            endDate,
            limit,
            offset
          )
        } else if (this.config.defaultAccountType === 'debit') {
          // to add get Debit details
        } else if (this.config.defaultAccountType === 'NACC') {
          response = await commonService.getNoticeAccTransactions(
            accountNumber,
            startDate,
            endDate,
            limit,
            offset
          )
        } else {
          response = await commonService.casaTransactions(
            accountNumber,
            startDate,
            endDate,
            limit,
            offset
          )
        }
        if (response) {
          return response
        }
      }
    },
    async getAllTransactions (accountNumber, startDate, endDate) {
      if (
        this.postingsRestrictions.includes(this.config.postingRestrictionType)
      ) {
        this.isAccountRestricted = true
      } else {
        this.isAccountRestricted = false
        let response = {}
        const allTransactions = []
        if (this.config.defaultAccountType === 'credit') {
          let page = 0
          while (page < 5) {
            response = await commonService.getCreditCardTransactions(
              accountNumber,
              startDate,
              endDate,
              30,
              30 * page
            )
            if (response.items) allTransactions.push(response)
            else break
            page++
          }
        } else if (this.config.defaultAccountType === 'debit') {
          // Todo
        } else if (this.config.defaultAccountType === 'NACC') {
          let page = 0
          while (page < 5) {
            response = await commonService.getNoticeAccTransactions(
              accountNumber,
              startDate,
              endDate,
              30,
              30 * page
            )
            if (response.items) allTransactions.push(response)
            else break
            page++
          }
        } else {
          let page = 0

          while (page < 5) {
            response = await commonService.casaTransactions(
              accountNumber,
              startDate,
              endDate,
              30,
              30 * page
            )
            if (response.items) allTransactions.push(response)
            else break
            page++
          }
        }
        if (allTransactions) {
          return allTransactions
        }
      }
    },
    toggleExpand (index) {
      this.expandedIndex = this.expandedIndex === index ? null : index
    },
    updateFormattedDate () {
      this.formattedFromDate = this.$formatter.formatDate(this.fromDate)
      this.formattedToDate = this.$formatter.formatDate(this.toDate)
    },
    resetFormattedDate () {
      this.fromDate = moment().format('YYYY-MM-DD')
      this.toDate = moment().format('YYYY-MM-DD')
      this.formattedFromDate = this.$formatter.formatDate(this.currentDate)
      this.formattedToDate = this.$formatter.formatDate(this.currentDate)
      this.itemGroups = {}
      this.items = []
    },
    showTransactions (val) {
      const self = this
      this.dateError = false
      this.offset = 0
      if (val === 'custom') {
        this.showCustomList = true
        this.showList = false
      } else {
        const startDate = moment().subtract(parseInt(val), 'days').format('YYYY-MM-DD')
        const endDate = moment().format('YYYY-MM-DD')
        this.showCustomList = false
        this.startDate = startDate
        this.endDate = endDate
        this.pagination.page = 1
        this.getTransactions(
          this.accountId,
          this.startDate,
          this.endDate,
          this.itemsPerPage,
          this.offset
        ).then((response) => {
          self.setData(response)
          self.items = response.items
          self.itemLinks = response.links
          self.showList = true
        })
      }
    },
    getCustomTransactionsHandler (fromDate, toDate) {
      // for custom date range do not call resetFormattedDate() - this will reset the selected dates - just clear the item array and itemGroup, set resetNotRequired to true
      this.itemGroups = {}
      this.items = []
      this.getCustomTransactions(fromDate, toDate, true, true)
    },
    async getCustomTransactions (startDate, endDate, isCustomDate, resetNotRequired) {
      const self = this
      self.pagination.page = 1
      !resetNotRequired && this.resetFormattedDate()
      if (
        this.postingsRestrictions.includes(this.config.postingRestrictionType)
      ) {
        this.isAccountRestricted = true
      } else {
        this.isAccountRestricted = false
        this.startDate = startDate
        this.endDate = endDate
        if (this.pagination.page > 1) {
          self.items = []
          self.itemGroups = []
          self.itemLinks = {}
        } else {
          this.offset = 0
        }
        if (startDate > endDate) {
          this.dateError = true
        } else {
          this.dateError = false
          if (this.offset === 0) {
            this.pagination.page = 1
          }
          await self
            .getTransactions(
              this.accountId,
              startDate,
              endDate,
              this.itemsPerPage,
              this.offset
            )
            .then((response) => {
              if (response && response.accountId) {
                self.setData(response)
                self.items = response.items
                self.itemLinks = response.links
                self.itemGroups = self.getItemGroup(self.items)
              } else if (response && this.config.defaultAccountType === 'credit') {
                self.setData(response)
                self.items = response.items
                self.itemLinks = response.links
                self.itemGroups = self.getItemGroup(self.items)
              }
              self.showList = true
            })
          if (self.items && self.items.length > 30) this.pageNumbers = 5
        }
      }
    },
    getColor (status) {
      return status === 'DEBIT' ? 'red' : 'green'
    },
    paginationChangeHandler (pageNumber) {
      this.pagination.page = pageNumber
      if (this.pagination.page >= 1) {
        this.offset = (this.pagination.page - 1) * this.itemsPerPage
        this.getTransactions(
          this.accountId,
          this.startDate,
          this.endDate,
          this.itemsPerPage,
          this.offset
        ).then((response) => {
          const self = this
          self.items = []
          self.itemGroups = []
          self.itemLinks = {}
          if (response && response.accountId) this.setData(response)
          else if (response && this.config.defaultAccountType === 'credit') this.setData(response)
          this.showList = true
        })
      }
    },
    setData (response) {
      if (response && response.items) {
        this.items = [...this.items, ...response.items]
        this.itemLinks = response.links
        // eslint-disable-next-line no-prototype-builtins
        for (const key in this.itemLinks) {
          if (this.itemLinks[key] === null) {
            delete this.itemLinks[key]
          }
        }
        if (
          this.itemLinks &&
          Object.keys(this.itemLinks).length > 1 &&
          this.itemLinks.hasOwnProperty('next')
        ) {
          if (this.pageNumbers >= 2) {
            this.pageNumbers = this.pagination.page + 1
          } else {
            this.pageNumbers = this.pagination.page - 1
          }
        }
        if (this.itemLinks && Object.keys(this.itemLinks).length === 1) {
          this.pageNumbers = this.pagination.page - 1
        }
      }
    },
    printCSVContent () {
      this.loaderEnabled = true
      const endDate = this.endDate
      const startDate = this.startDate
      this.getAllTransactions(this.accountId, startDate, endDate).then((csvData) => {
        let csv = 'Date,Description,Amount,Credit/Debit,Balance\n'
        csvData.forEach((row) => {
          row.items.forEach((data) => {
            csv += ' ' + this.$formatter.formatDate(data.bookingDateTime.substr(0, 10)) + ','
            csv += data.description + ','
            csv += data.amount.amount + ' ' + data.amount.currency + ','
            csv += data.creditDebitIndicator + ','
            csv += data.clearedBalance.amount + ' ' + data.clearedBalance.currency
            csv += '\n'
          })
        })
        const anchor = document.createElement('a')
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
        anchor.target = '_blank'
        anchor.download = this.accountId + '_' + this.currentDate.substr(8, 2) + this.currentDate.substr(5, 2) + this.currentDate.substr(0, 4) + '_' + new Date().valueOf() + '.csv'
        anchor.click()
      })
      this.loaderEnabled = false
    },
    printPdfContent () {
      this.loaderEnabled = true
      // eslint-disable-next-line new-cap
      var pdf = new jsPDF('p', 'mm', 'A4')
      const element = document.getElementById('pdfContent')
      html2canvas(element, {
        logging: true,
        letterRendering: true,
        allowTaint: false,
        useCORS: true,
        scale: (1920 * 2) / window.innerWidth,
        backgroundColor: '#fff'
      }).then((canvas) => {
        var image = canvas.toDataURL('image/jpeg', 0.9)
        pdf.setFontSize(14)
        pdf.text(80, 10, 'Account Transactions \n')
        pdf.setFontSize(8)
        pdf.text(67, 15, `For the period from ${this.$formatter.formatDate(this.startDate)} to ${this.$formatter.formatDate(this.endDate)} (Page ${this.pagination.page})\n`)
        pdf.setFontSize(10)
        pdf.text(80, 20, `Account Number: ${this.accountId}\n`)
        pdf.setFontSize(10)
        pdf.text(10, 24, '_____________________________________________________________________________________________')
        pdf.addImage(image, 'JPEG', 10, 25, 180, 0)
        pdf.save('transactions.pdf')
        this.loaderEnabled = false
      })
    },
    getDate (val) {
      return moment().subtract(parseInt(val), 'days').format('YYYY-MM-DD')
    },
    thisMonthTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(30)
      self.getCustomTransactions(startDate, endDate)
    },
    lastMonthTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(60)
      self.getCustomTransactions(startDate, endDate)
    },
    last15DaysTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(15)
      self.getCustomTransactions(startDate, endDate)
    },
    last7DaysTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(7)
      self.getCustomTransactions(startDate, endDate)
    },
    async last180DaysTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(180)
      await self.getCustomTransactions(startDate, endDate)
    },
    last360DaysTransactions (resetNotRequired) {
      const self = this
      self.expandCustomList = false
      const endDate = self.getDate(181)
      const startDate = self.getDate(360)
      resetNotRequired ? self.getCustomTransactions(startDate, endDate, true, true) : self.getCustomTransactions(startDate, endDate, true)
    },
    getItemGroup (items, isCustomDate) {
      const self = this
      const groupResult = _.groupBy(items, function (item) {
        return self.$formatter.formatDate(item.valueDateTime.substr(0, 10))
      })
      self.itemGroups = groupResult
    },
    formatItemDescription (description) {
      const formattedDescription = description.replace('EUR-Payment-STEP2', 'EUR Payment STEP2')
      return formattedDescription
    },
    showCustomFilterList () {
      this.expandCustomList = true
    },
    async getNoticeAccTransactions () {
      const self = this
      self.getTransactions(
        this.accountId
      )
        .then((response) => {
          self.setData(response)
          self.items = response.items
          self.itemLinks = response.links
          self.itemGroups = self.getItemGroup(self.items)
          self.showList = true
        })
    }
  },
  watch: {
    items () {
      this.noOfPages = Math.ceil(this.items.length / this.itemsPerPage)
    },
    dateError () {
      if (this.dateError) {
        this.items = []
      }
    }
  }
}
</script>
